import React from "react"
import { SwitchWrapper } from "./Switch.style"

const Switch = ({ checked }) => {
  return <SwitchWrapper type="checkbox" checked={checked} readOnly />
}

export default Switch
